import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  headerStyle: {
    backgroundColor: Colors.darkRed,
  },
  headerTexts: {
    color: 'white',
  },
  scrollviewContainer: {
    paddingBottom: 150,
    paddingHorizontal: 16,
    marginTop: 120,
  },
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  stepDesc: {
    fontSize: Fonts.size.regular,
    color: Colors.dark_grey,
  },
  descOfferContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  offerPriceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  offerPrice: {
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
    fontSize: Fonts.size.regular,
  },
  offerPeriod: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.dark_grey,
    fontSize: Fonts.size.regular,
  },
  offerOriginalPrice: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.light_grey,
    fontSize: Fonts.size.regular,
    textDecorationLine: 'line-through',
  },
  itemContentContainer: {
    backgroundColor: Colors.whiteSmoke,
    marginBottom: 5,
  },
  rowContainer: {
    padding: 20,
  },
  rowItem: {
    flexDirection: 'row',
    paddingVertical: 10,
  },
  itemRowTitle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regular,
    color: Colors.dark_grey,
    marginLeft: 16,
  },
  offerBottomContent: {
    backgroundColor: Colors.white,
    padding: 16,
  },
  descOfferStyle: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
  },
  offerIconsContainer: {
    flexDirection: 'row',
    marginVertical: 12,
  },
  itemIcon: {
    marginRight: 20,
  },
  offerBtnContainer: {
    borderTopWidth: 1,
    borderTopColor: Colors.lightGrey,
    paddingHorizontal: 16,
    backgroundColor: Colors.white,
    paddingBottom: 20,
  },
  btnStyle: {
    marginTop: 20,
    marginBottom: 0,
  },
  titleOfferStyle: {
    color: Colors.dark_grey,
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  offerCardStyle: {
    marginHorizontal: 0,
    marginTop: 20,
  },
  // Modal non scrollable content
  modalContentContainerWraper: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingVertical: 32,
  },
  modalContentWraper: {
    flexGrow: 1,
    marginTop: 64,
    justifyContent: 'center',
    alignItems: 'center',

  },
  verticalSpacing: {
    marginTop: 35,
    marginBottom: 16,
  },
  modalContentWraper2: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default styles
